import Vue from 'vue'
import Router from 'vue-router'
import SetupInfo from '@/components/SetupInfo'
import Fraud from '@/components/Fraud'
import Engagement from '@/components/Engagement'
import Insights from '@/components/Insights'
import Voluum from '@/components/Voluum'
import Audience from '@/components/Audience'
import Admin from '@/components/Admin'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'setup',
      component: SetupInfo,
    },
    {
      path: '/fraud/:template?/:back?',
      name: 'fraud',
      component: Fraud,
      props: true
    },
    {
      path: '/engagement/:template?/:back?',
      name: 'engagement',
      component: Engagement,
      props: true
    },
    {
      path: '/audience/:template?/:back?',
      name: 'audience',
      component: Audience,
      props: true
    },
    {
      path: '/voluum',
      name: 'voluum',
      component: Voluum,
    },
    {
      path: '/insights',
      name: 'insights',
      component: Insights,
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
    }
  ]
})

router.beforeEach((to, from, next) => {
  if ((to.fullPath === '/admin') && !from.name) {
    next('/');
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js